var map = {
	"./image1.png": 74535,
	"./image10.png": 61671,
	"./image2.png": 38124,
	"./image3.png": 23573,
	"./image4.png": 67066,
	"./image5.png": 68291,
	"./image6.png": 83016,
	"./image7.png": 97233,
	"./image8.png": 68950,
	"./image9.png": 65279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19593;